import ActionType from './actionType';

export const setShowWarning = (state) => ({
  type: ActionType.SET_SHOW_WARNING,
  payload: { showWarning: state },
});
